import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const MixedBedUnitsMb: React.FC = () => {
  return (
    <>
      <PageHeader title="Mixed Bed Units (MB)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-2.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Mixed Bed Units (MB)</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Mixed Bed Units (MB) are advanced ion exchange systems that deliver ultra-pure demineralized water by removing both cations and anions in a single step. These units are typically used as polishing filters after a two-bed DM plant or RO system, where ultrapure water is essential for critical processes.</p>
              <p>At Wasser Technochem (India) Ltd., we engineer mixed bed polishers for high-purity water applications in power, electronics, pharmaceutical, and process industries, ensuring consistent conductivity levels below 1 µS/cm.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-filter text-primary me-2"></i>Final polishing after RO or DM plants</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Boiler feedwater for high-pressure turbines</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Electronics and semiconductor manufacturing</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Laboratory and pharmaceutical-grade water</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Condensate polishing systems</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Battery water generation</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL offers high-capacity, high-efficiency MB units with custom configurations to meet industry-specific water quality goals.</p>
              
              <div className="mb-4">
                <h5><i className="fa fa-exchange-alt text-primary me-2"></i>Strong Acid Cation & Strong Base Anion Resin Mix</h5>
                <p className="ms-4">Optimized in a uniform ratio for maximum ion removal.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-industry text-primary me-2"></i>Pressure Vessel MOCs: FRP / MSRL / SS 316</h5>
                <p className="ms-4">Chosen based on temperature, pressure, and chemical compatibility.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cogs text-primary me-2"></i>Manual / Semi-Auto / PLC-Based Operation</h5>
                <p className="ms-4">With resin regeneration, air mixing, and rinsing functions.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-sliders-h text-primary me-2"></i>Custom Resin Bed Depth and Flow Configurations</h5>
                <p className="ms-4">To suit varying demands of TDS, flow rates, and polishing time.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Achieves ultrapure water quality &lt; 0.5 µS/cm</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Ideal for high-pressure boiler applications</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>High Output before Regeneration (OBR) ensuring operational cost in check</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Easy to integrate into existing DM/RO systems</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Specialized in power and chemical sector installations</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house expertise in resin loading and regeneration planning</p>
              <p><i className="fa fa-star text-warning me-2"></i>End-to-end integration with DM, RO, and condensate polishing units</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>O&M service support with performance tracking</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default MixedBedUnitsMb;
